import { useState } from 'react';
import { PaymentAddComponentProps } from '../../../contracts';
import { CardForm } from '../../card-helpers';
export function PayPalAddCreditCard({ onSuccess, completeIntent, intentData, onCancel, showSave }: PaymentAddComponentProps) {
	const [errors, setErrors] = useState<string[]>([]);

	const intent = intentData as {
		intentId: string;
	};

	const submitFunc = submitData => {
		completeIntent(
			intent.intentId,
			JSON.stringify({
				name: submitData.cardHolder,
				expiry: { month: submitData.expires.month, year: submitData.expires.year },
				number: submitData.cardNumber,
				cvv: submitData.cvv
			})
		)
			.then(result => {
				if (!result) {
					setErrors(['Failed to create the new payment method']);
					return;
				}
				onSuccess(result);
			})
			.catch(error => {
				setErrors(['Unable to save credit card details']);
			});
	};

	return <CardForm onCancel={onCancel} submitFunc={submitFunc} apiErrors={errors} showSave={showSave} />;
}
